import type { UpdateIssueArgs } from "@productlane/zero/types"
import { LinearIcon } from "@productlane/ui"
import { mutators } from "@productlane/zero/mutators"

import { toast } from "@/components/toast"
import { analytics } from "@/lib/analytics"
import { mutateOk, reportServerRejection, useZero } from "@/lib/zero"

/** Saves through the issue mutator, which writes Linear first and rolls back if it refuses. */
export const useSaveIssueToLinear = (issueId: string) => {
	const zero = useZero()
	const reportFailure = (message?: string) =>
		toast.error({
			title: "Linear did not save this change",
			description: message,
			icon: LinearIcon,
		})
	return async (update: Omit<UpdateIssueArgs, "id">, event: string) => {
		try {
			await mutateOk(
				reportServerRejection(
					zero.mutate(mutators.issues.update({ id: issueId, ...update })),
					reportFailure,
				),
			)
			analytics.track(event)
		} catch (error) {
			reportFailure(error instanceof Error ? error.message : undefined)
		}
	}
}
